var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiloDownFillArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66465 8.78139L10.2406 5.20539L11.1834 6.14819L5.99798 11.3337L0.8125 6.14819L1.75531 5.20539L5.33131 8.78139L5.33131 0.666992L6.66465 0.666992L6.66465 8.78139Z",
    fill: "#F1313E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiloDownFillArrow);
export default __webpack_public_path__ + "static/media/hilo-down-fill-arrow.6920284d657269d48436a0055818b714.svg";
export { ForwardRef as ReactComponent };